import { render, staticRenderFns } from "./VDLIndex.vue?vue&type=template&id=23e446f0"
import script from "./VDLIndex.vue?vue&type=script&lang=js"
export * from "./VDLIndex.vue?vue&type=script&lang=js"
import style0 from "./VDLIndex.vue?vue&type=style&index=0&id=23e446f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports